var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "start-page-product-tabs ci-card" },
    [
      _c("h2", {
        domProps: {
          textContent: _vm._s(
            _vm.$t("ui.components.start.products_tabs.title")
          ),
        },
      }),
      _vm._v(" "),
      _c(
        "b-tabs",
        {
          staticClass: "ci-tabs",
          attrs: {
            "replace-url": false,
            "tracking-overwrites": {
              source: { name: "StartPageProductsTabs" },
            },
          },
        },
        [
          _c(
            "b-tab",
            {
              attrs: {
                id: "watchlist",
                title: _vm.$t(
                  "ui.components.start.products_tabs.tabs.watchlist.title",
                  { count: _vm.watchlistProductsCount }
                ),
              },
            },
            [
              _c("watchlist-carousel", {
                staticClass: "mt-3",
                attrs: {
                  watchlist: _vm.watchlistProducts,
                  "watchlist-count": _vm.watchlistProductsCount,
                  "show-title": false,
                  loading: _vm.watchlistLoading,
                },
                on: { "tracking-click": _vm.propagateTrackClick },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            {
              attrs: {
                id: "comparisons",
                title: _vm.$t(
                  "ui.components.start.products_tabs.tabs.comparisons.title",
                  { count: _vm.comparisonsCount }
                ),
              },
            },
            [
              _c("comparisons-carousel", {
                staticClass: "mt-3",
                attrs: {
                  comparisons: _vm.comparisons,
                  "comparisons-count": _vm.comparisonsCount,
                  "show-title": false,
                  loading: _vm.comparisonsLoading,
                },
                on: { "tracking-click": _vm.propagateTrackClick },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            {
              attrs: {
                id: "portfolios",
                title: _vm.$t(
                  "ui.components.start.products_tabs.tabs.portfolios.title",
                  { count: _vm.portfoliosCount }
                ),
              },
            },
            [
              _c("portfolios-carousel", {
                staticClass: "mt-3",
                attrs: {
                  portfolios: _vm.portfolios,
                  "portfolios-count": _vm.portfoliosCount,
                  "show-title": false,
                  loading: _vm.portfoliosLoading,
                },
                on: { "tracking-click": _vm.propagateTrackClick },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }